var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"contenteditable":_vm.editMode,"for":_vm.forInput},domProps:{"innerHTML":_vm._s(_vm.choice)},on:{"blur":function($event){return _vm.editFormItemLabel($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.exitEdit($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }